import styled from 'styled-components';

import { mediaMin, tabletRange } from '@spa/shared/theme';

export const Wrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.space(2)} ${props => props.theme.space(3)};
  color: ${props => props.theme.unisystem.chip.color};
  background-color: ${props => props.theme.unisystem.chip.background.default};
  border: ${props => props.theme.rem(1)} solid ${props => props.theme.unisystem.chip.border.default};
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(14)};
  height: ${props => (props.isSmall ? props.theme.rem(30) : props.theme.rem(38))};
  min-width: ${props => props.minWidth || props.theme.rem(130)};
  border-radius: 20px;
  cursor: pointer;

  ${tabletRange.ipad()`
    padding: 6px ${props => props.theme.space(3)};
  `}

  svg {
    margin-right: ${props => props.theme.space(2)};
  }

  ${mediaMin.smallBreakpoint`
    padding-top: ${props => props.theme.space(1.5)};
    padding-bottom: ${props => props.theme.space(1.5)};
  `}

  ${props =>
    props.isSelected &&
    `
      border: ${props.theme.rem(2)} solid ${props.theme.unisystem.chip.border.selected};
      background-color: ${props.theme.unisystem.chip.background.selected};
  `}

  ${props =>
    props.isPrimary &&
    `
      border: ${props.theme.rem(2)} solid ${props.theme.unisystem.chip.border.primary};
      background-color: ${props.theme.unisystem.chip.background.primary};
  `}

  &:hover {
    background-color: ${props => props.theme.unisystem.chip.background.hover};
  }
`;
